// src/store/venueSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isBulkEnquiryOpen: false,
  selectedVenues: [],
  isBulkEnquiryModal: false,
  enquiryType: "venue"
};

const bulkEnquirySlice = createSlice({
  name: "bulkEnquiry",
  initialState,
  reducers: {
    openBulkEnquiry: (state) => {
      state.isBulkEnquiryOpen = true;
    },
    closeBulkEnquiry: (state) => {
      state.selectedVenues = [];
      state.isBulkEnquiryOpen = false;
      state.enquiryType = "venue";
    },
    addVenue: (state, action) => {
      let findVenue = state.selectedVenues.find(d => d._id === action.payload._id);
      if(!findVenue) state.selectedVenues.push(action.payload);
      else state.selectedVenues = state.selectedVenues.filter(u => u._id !== action.payload._id)
    },
    setSelectedVenues: (state, action) => {
      state.selectedVenues = action.payload;
    },
    clearSelectedVenues: (state) => {
      state.selectedVenues = [];
      state.isBulkEnquiryOpen = false;
      state.enquiryType = "venue";
    },
    setBulkEnquiryModal: (state, action) => {
      state.isBulkEnquiryModal = action.payload;
    },
    setEnquiryType: (state, action) => {
      state.enquiryType = action.payload;
    }
  }
});

export const {
  openBulkEnquiry,
  closeBulkEnquiry,
  addVenue,
  setSelectedVenues,
  clearSelectedVenues,
  setBulkEnquiryModal,
  setEnquiryType
} = bulkEnquirySlice.actions;

export default bulkEnquirySlice.reducer;
